import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { isMatch } from 'lodash'
import { submit, reset } from 'redux-form';

import { getCookieValue } from 'app/actions/genericActionCreator'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import { genericPostingActionCreator } from 'app/actions/genericActionCreator'
import { uploaderInit, removeFile, startUpload, setOption, destroy, invokeTidewater, uploadSalesContract } from '../../actions/postAssignmentInfoAction'
import { fetchAssignmentDetailByLin } from '../../actions/fetchAssignmentDetailAction'
import UploadsDisabledMessage from './UploadsDisabledMessage'
import ErrorMessage from './ErrorMessage'
import RequesterDetailsSection from './RequesterDetailsSection'
import AssignmentDetailsSection from './AssignmentDetailsSection'
import PropertyDescriptionAndPurchaserSection from './PropertyDescriptionAndPurchaserSection'
import DocumentsUploadSection from './DocumentsUploadSection'
import AppraisalReportIndicator from './AppraisalReportIndicator'
import UploadSuccessOrFailureMessage from './UploadSuccessOrFailureMessage'
import InvokeTidewater from './InvokeTidewater'
import DocumentsUploadHistory from '../common/DocumentsUploadHistory'

class AssignmentSummary extends Component {
  constructor(props) {
    super(props)
    this.state = { ...this.getInitialState(this.props.assignmentDetails) }
    this.appraisalReportRef = React.createRef()
    this.salesContractRef = React.createRef()
  }

  getInitialState = (assignmentDetails) => {
    let initialState = {
      lin: assignmentDetails.lin,
      streetNumber: assignmentDetails.streetNumber || '',
      addressLineOne: assignmentDetails.addressOne || '',
      addressLineTwo: assignmentDetails.addressTwo || '',
      city: assignmentDetails.city || '',
      zipPrefix: assignmentDetails.zip || '',
      zipSuffix: assignmentDetails.zipSuffix || '',
      legalDescription: assignmentDetails.legalText || '',
      exteriorOnlyIndicator: assignmentDetails.exteriorOnlyAppraisalReport || '',
      tidewater: assignmentDetails.tidewater || false,
      tidewaterNote: assignmentDetails.tidewaterNote || '',
      revisionComments: '',
      appraisalReport: null,
      salesContract: null,
      appraisalReportMessage: null,
      salesContractMessage: null,
      invalidMessage: [],
      salesContractFileUploaded: false,
      salesContractLGYUploaded: false
    }
    return initialState
  }

  componentDidMount() {
    const appraisalPluploadOptions = {
      handle: 'appraisalReportUploader',
      runtimes: 'html5,html4',
      browse_button: this.appraisalReportRef.current,
      container: 'documents-upload',
      chunk_size: '2mb',
      max_file_size: '100mb',
      max_retries: '5',
      prevent_duplicates: false,
      multi_selection: false,
      max_file_count: 1,
      multiple_queues: false,
      url: `/lgyhub/api/appraiser-workspace/upload/appraisal-report`,
      headers: {
        'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      },
      filters: [
        { title: 'Allowed files', extensions: 'xml' }
      ],
      multipart_params: {}
    }

    this.props.uploaderInit(appraisalPluploadOptions)
  }

  componentDidUpdate(prevProps) {
    const { assignmentDetails, appraiserUploads, fetchAssignmentDetailByLin, chunkedUpload, chunkError, initError } = this.props

    if (this.state.salesContractFileUploaded && chunkedUpload.uploadChunk.uploadComplete) {
      this.setState(prevState => ({
        ...prevState,
        salesContractFileUploaded: false,
        salesContractLGYUploaded: true
      }))
      this.createSalesContractPayload()
    }
    if (assignmentDetails.lin !== this.state.lin) {
      this.setState({ ...this.getInitialState(assignmentDetails) })
    }
    if (appraiserUploads.appraisalReport.files !== prevProps.appraiserUploads.appraisalReport.files) {
      this.handleFileChanges('appraisalReportUploader', appraiserUploads.appraisalReport.files)
    }
    if (appraiserUploads.appraisalReport.error !== prevProps.appraiserUploads.appraisalReport.error) {
      this.handleUploaderErrors(appraiserUploads)
    }
    if (appraiserUploads.salesContract.responseMessage !== prevProps.appraiserUploads.salesContract.responseMessage
      && appraiserUploads.salesContract.responseMessage && this.state.salesContractLGYUploaded) {
        this.setState(prevState => ({
          ...prevState,
          salesContractMessage: appraiserUploads.salesContract.responseMessage, 
          salesContractLGYUploaded: false
        }))
      if (appraiserUploads.salesContract.responseMessage === 'Y') {
        this.props.reset('appraisalSalesContractUpload')
      }
      fetchAssignmentDetailByLin(assignmentDetails.lin)
    }
    if (appraiserUploads.appraisalReport.responseMessage !== prevProps.appraiserUploads.appraisalReport.responseMessage
      && appraiserUploads.appraisalReport.responseMessage) {
      this.setState({
        appraisalReportMessage: appraiserUploads.appraisalReport.responseMessage,
        invalidMessage: appraiserUploads.appraisalReport.responseReason ? [appraiserUploads.appraisalReport.responseReason] : []
      })
      fetchAssignmentDetailByLin(assignmentDetails.lin)
    }    
    if ((chunkError !== prevProps.chunkError || initError !== prevProps.initError) && (initError || chunkError) && this.state.salesContractFileUploaded) {
      this.setState(prevState => ({
        ...prevState,
        salesContractFileUploaded: false,
        salesContractMessage: 'N',
        salesContractLGYUploaded: false
      }))
      fetchAssignmentDetailByLin(assignmentDetails.lin)
    }
  }

  componentWillUnmount() {
    this.props.destroy('appraisalReportUploader')
  }

  handleChange = (event) => {
    if (event.target.name === 'zipPrefix' || event.target.name === 'zipSuffix') {
      this.setState({ [event.target.name]: event.target.value.replace(/(\D)*/, ''), invalidMessage: [] })
    } else {
      this.setState({ [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value, invalidMessage: [] })
    }
  }

  handleUploaderErrors = (appraiserUploads) => {
    if (appraiserUploads.appraisalReport.error === 'File size error.') {
      this.setState({
        invalidMessage: ['Appraisal Report file size must be greater than 0 KB and less than 15 MB.']
      })
    }
    if (appraiserUploads.appraisalReport.error === 'File extension error.') {
      this.setState({
        invalidMessage: ['Only XML files may be uploaded for Appraisal Reports.']
      })
    }
    if (appraiserUploads.salesContract.error === 'File size error.') {
      this.setState({
        invalidMessage: ['Sales Contract file size must be greater than 0 KB and less than 9.5 MB.']
      })
    }
    if (appraiserUploads.salesContract.error === 'File extension error.') {
      this.setState({
        invalidMessage: ['Only .pdf, .doc, .docx, .xlsx, .xls, .tif, .tiff, .gif, .jpg, .jpeg, and .png file extensions are supported for Sales Contract.']
      })
    }
  }

  handleFileChanges = (handle, files) => {
    if (files.length === 1 && files[0].status === 1) {
      this.setState({ [handle.replace('Uploader', '')]: files[0].name, invalidMessage: [] })
    } else if (files.length === 2) {
      this.setState({ [handle.replace('Uploader', '')]: files[1].name, invalidMessage: [] })
      this.props.removeFile(files[0].id, handle)
    }
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { assignmentDetails, startUpload, invokeTidewater, appraiserUploads, submit, salesContractUpload } = this.props
    if (this.state.appraisalReport) {
      this.props.setOption({
        option: 'multipart_params', value: {
          id: appraiserUploads.appraisalReport.id+new Date(),
          documentType: 'APPRAISAL_REPORT',
          propertyAppraisalId: assignmentDetails.id,
          fileName: this.state.appraisalReport,
          streetNumber: this.state.streetNumber,
          addressLineOne: this.state.addressLineOne,
          addressLineTwo: this.state.addressLineTwo,
          city: this.state.city,
          zipPrefix: this.state.zipPrefix,
          zipSuffix: this.state.zipSuffix,
          legalDescription: this.state.legalDescription,
          exteriorOnlyAppraisalReport: this.state.exteriorOnlyIndicator,
          freeText: this.state.revisionComments
        }
      }, 'appraisalReportUploader')
      startUpload('appraisalReportUploader')
      // Disable the "Choose File" button after user presses submit button to prevent 
      // changing the file during upload process which causes errors.
      assignmentDetails.isUploadingDisabled=true;
    } else if (!(salesContractUpload?.values?.file) && !this.state.tidewater) {
      this.setState(prevState => ({
        invalidMessage: [...prevState.invalidMessage,
          'Valid Appraisal Report is required. File size must be greater than 0 KB and less than 15 MB.']
      }))
    }
    if (salesContractUpload?.values?.file) {
      this.props.genericPostingActionCreator('CHUNK_UPLOAD', 'posted', { uploadComplete: false })
      submit('appraisalSalesContractUpload')
      this.setState(prevState => ({
          ...prevState,
          salesContractFileUploaded: true,
          salesContractLGYUploaded: false
        }))
      // Disable the "Choose File" button after user clicks submit button to prevent 
      // changing the file during upload process which causes errors.
      assignmentDetails.isUploadingDisabled=true;
    } else if (!this.state.appraisalReport && !this.state.tidewater) {
      this.setState(prevState => ({
        invalidMessage: [...prevState.invalidMessage,
          'Valid Sales Contract is required. File size must be greater than 0 KB and less than 9.5 MB.']
      }))
    }

    if (this.state.tidewater && !assignmentDetails.tidewater) {
      invokeTidewater(assignmentDetails.id, this.state.tidewaterNote, assignmentDetails.lin)
    }
    
    // not resetting all of the state because I believe it would confuse the user to see
    // the address/legal text change back to their initial state after submitting
    this.setState({ revisionComments: '', appraisalReport: null})
  }

  handleInvalid = (event) => {
    event.preventDefault()
    let name = event.target.name.replace(/([A-Z])/g, ' $1')
    name = name.replace(/^./, (char) => char.toUpperCase())
    this.setState(prevState => ({ invalidMessage: [...prevState.invalidMessage, name] }))
    if (!this.state.appraisalReport && !this.state.tidewater) {
      this.setState(prevState => ({
        invalidMessage: [...prevState.invalidMessage,
          'Valid Sales Contract is required. File size must be greater than 0 KB and less than 9.5 MB.',
          'Valid Appraisal Report is required. File size must be greater than 0 KB and less than 15 MB.']
      }))
    }
  }

  handleReset = () => {
    if (this.state.appraisalReport) {
      this.props.removeFile(this.props.appraiserUploads.appraisalReport.files[0].id, 'appraisalReportUploader')
    }
    if (this.props.salesContractUpload?.values?.file) {
      this.props.reset('appraisalSalesContractUpload')
    }
    this.setState({ ...this.getInitialState(this.props.assignmentDetails)})
  }

  createSalesContractPayload = () => {
    const { chunkedUpload, assignmentDetails, salesContractUpload, uploadSalesContract } = this.props

    const payload = {
      fileId: chunkedUpload.initializeChunkedUploads.fileId,
      documentType: 'SALES_CONTRACT',
      propertyAppraisalId: assignmentDetails.id,
      fileName: salesContractUpload.values.file.name,
      streetNumber: this.state.streetNumber,
      addressLineOne: this.state.addressLineOne,
      addressLineTwo: this.state.addressLineTwo,
      city: this.state.city,
      zipPrefix: this.state.zipPrefix,
      zipSuffix: this.state.zipSuffix,
      legalDescription: this.state.legalDescription,
      exteriorOnlyAppraisalReport: this.state.exteriorOnlyIndicator,
      freeText: this.state.revisionComments
    }
    uploadSalesContract(payload)
  }

  render() {
    const { assignmentCorrespondence, assignmentDetails, appraiserUploads, user, tidewater, salesContractUpload } = this.props
    const correspondence = assignmentCorrespondence.allCorrespondence ? assignmentCorrespondence.allCorrespondence : [];
    const appraisalReportUploading = appraiserUploads.appraisalReport.state === 2
    const isInvalid = this.state.invalidMessage.length > 0 || (!!(salesContractUpload?.syncErrors) && salesContractUpload?.values?.file)
    const submitFailed = this.state.salesContractMessage === 'N' || this.state.appraisalReportMessage === 'N'
    const submitSucceeded = this.state.salesContractMessage === 'Y' || this.state.appraisalReportMessage === 'Y' || tidewater.message === 'tidewater invoked'
    const shouldDisplayAppraisalReportIndicator = assignmentDetails.appraisalCode === 'SAPP' || assignmentDetails.appraisalCode === 'LGI' || assignmentDetails.appraisalCode === 'LPL'
    // tidewater is being hidden per PMDI request as of 20.5, uncomment below to display
    const shouldDisplayTidewater = false //assignmentDetails.appraisalCode === 'LAPP' || (assignmentDetails.appraisalCode === 'IND' && !assignmentDetails.nadlAppraisalIndicator)

    return (
      <div className='assignment-summary'>
        <form className='usa-form' onSubmit={this.handleSubmit}>
          {isInvalid && !submitFailed && <ErrorMessage />}
          {assignmentDetails.isUploadingDisabled && <UploadsDisabledMessage reason={assignmentDetails.uploadingDisabledReason} />}
          {this.state.salesContractMessage && <UploadSuccessOrFailureMessage
            documentTypeName='Sales Contract'
            responseMessage={this.state.salesContractMessage} />}
          {this.state.appraisalReportMessage && <UploadSuccessOrFailureMessage
            documentTypeName={`Appraisal Report. ${(this.state.invalidMessage.some(error => error?.toLowerCase().includes('appraisal report')) &&
          this.state.invalidMessage.find(error => error?.toLowerCase().includes('appraisal report'))) || ''}`}
            responseMessage={this.state.appraisalReportMessage} />}
          {assignmentDetails.appraiserResponseDiaryDateString && <LgyAlertDialog type='error' heading='Response Required'
            text={`Response is required by the Appraiser. Due Date: ${assignmentDetails.appraiserResponseDiaryDateString}`} />}
          <div className='usa-width-one-whole'>

            <div className='usa-width-one-half'>
              <RequesterDetailsSection assignmentDetails={assignmentDetails} />
              <AssignmentDetailsSection
                assignmentDetails={assignmentDetails}
                invalidMessage={this.state.invalidMessage}
                isUploadingDisabled={assignmentDetails.isUploadingDisabled}
                legalDescription={this.state.legalDescription}
                bifurcationUsed={this.state.bifurcationUsed}
                handleInvalid={this.handleInvalid}
                handleChange={this.handleChange} />
              {shouldDisplayTidewater && <InvokeTidewater
                tidewaterDisabled={assignmentDetails.isUploadingDisabled || assignmentDetails.dispositionCode !== 'O'}
                tidewaterAlreadySet={assignmentDetails.tidewater}
                tidewater={this.state.tidewater}
                tidewaterNote={this.state.tidewaterNote}
                handleChange={this.handleChange}
                handleInvalid={this.handleInvalid}
                invalidMessage={this.state.invalidMessage} />}
              {shouldDisplayAppraisalReportIndicator && <AppraisalReportIndicator
                isUploadingDisabled={assignmentDetails.isUploadingDisabled}
                exteriorOnlyIndicator={this.state.exteriorOnlyIndicator}
                handleChange={this.handleChange}
                handleInvalid={this.handleInvalid}
                invalidMessage={this.state.invalidMessage} />}
            </div>
            <div className='usa-width-one-half'>
              <PropertyDescriptionAndPurchaserSection
                assignmentDetails={assignmentDetails}
                invalidMessage={this.state.invalidMessage}
                isUploadingDisabled={assignmentDetails.isUploadingDisabled}
                legalDescription={this.state.legalDescription}
                handleInvalid={this.handleInvalid}
                handleChange={this.handleChange}
                streetNumber={this.state.streetNumber}
                addressLineOne={this.state.addressLineOne}
                addressLineTwo={this.state.addressLineTwo}
                city={this.state.city}
                zipPrefix={this.state.zipPrefix}
                zipSuffix={this.state.zipSuffix} />
            </div>
          </div>
          <div className='usa-width-one-whole'>
            <DocumentsUploadSection
              assignmentDetails={assignmentDetails}
              isUploadingDisabled={assignmentDetails.isUploadingDisabled}
              handleInvalid={this.handleInvalid}
              handleChange={this.handleChange}
              invalidMessage={this.state.invalidMessage}
              revisionComments={this.state.revisionComments}
              correspondence={correspondence}
              appraisalReport={this.state.appraisalReport}
              appraisalReportRef={this.appraisalReportRef}
              salesContractRef={this.salesContractRef} />
            <LgyFormSubmit
              pristine={isMatch(this.getInitialState(this.props.assignmentDetails), this.state) && !!!appraiserUploads.salesContractMessage && !!!appraiserUploads.appraisalReportMessage && !(salesContractUpload?.values?.file)}
              submitting={appraisalReportUploading || this.state.salesContractFileUploaded || this.state.salesContractLGYUploaded}
              percent={appraisalReportUploading ? appraiserUploads.appraisalReport.total.percent : undefined}
              submitFailed={appraiserUploads.error || submitFailed}
              submitSucceeded={submitSucceeded}
              invalid={isInvalid || assignmentDetails.isUploadingDisabled}
              reset={this.handleReset} />
          </div>
        </form>
        <div className='usa-width-one-whole'>
          <DocumentsUploadHistory
            correspondence={correspondence}
            username={user.portalId}
            fetching={assignmentCorrespondence.fetching}
            error={assignmentCorrespondence.error}
            summaryPage
            lin={assignmentDetails.lin} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  appraiserUploads: state.appraiser.assignments.appraiserUploads,
  user: state.currentUser,
  tidewater: state.appraiser.assignments.tidewater,
  chunkedUpload: state.chunkedUploads,
  salesContractUpload: state.form.appraisalSalesContractUpload,
  chunkError: state.chunkedUploads.uploadChunk?.error,
  initError: state.chunkedUploads.initializeChunkedUploads?.error
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ uploaderInit, removeFile, startUpload, setOption, destroy, fetchAssignmentDetailByLin, invokeTidewater, submit, reset, uploadSalesContract, genericPostingActionCreator }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentSummary)